import {
    devicesFulfilledConstants,
    devicesPendingConstants,
    devicesRejectedConstants,
    myAssetsFulfilledConstants,
    myAssetsPendingConstants,
    myAssetsRejectedConstants
} from '../actions';

const initialState = {
    device: {
        items: [],
        total: 0,
        loading: true
    },
    mobileDevice: {
        items: [],
        total: 0,
        loading: true
    },
    reservedDevice: {
        items: [],
        total: 0,
        loading: true
    },
    transitedDevice: {
        items: [],
        total: 0,
        loading: true
    },
    license: {
        items: [],
        total: 0,
        loading: true
    },
    error: ''

};

export default function (state = initialState, action) {
    switch (action.type) {
        case myAssetsPendingConstants.MY_ASSETS_DEVICE_LOADED:
            return {
                ...state,
                device: {
                    ...state.device,
                    loading: true
                }
            };

        case myAssetsPendingConstants.MY_ASSETS_MOBILE_DEVICE_LOADED:
            return {
                ...state,
                mobileDevice: {
                    ...state.mobileDevice,
                    loading: true
                }
            };

        case myAssetsPendingConstants.MY_ASSETS_RESERVATION_LOADED:
            return {
                ...state,
                reservedDevice: {
                    ...state.reservedDevice,
                    loading: true
                }
            };

        case myAssetsPendingConstants.MY_ASSETS_TRANSITION_LOADED:
            return {
                ...state,
                transitedDevice: {
                    ...state.transitedDevice,
                    loading: true
                }
            };

        case myAssetsPendingConstants.MY_ASSETS_LICENSE_LOADED:
            return {
                ...state,
                license: {
                    ...state.license,
                    loading: true
                }
            };

        case myAssetsFulfilledConstants.MY_ASSETS_DEVICE_LOADED:
            return {
                ...state,
                device: {
                    items: action.payload.items,
                    total: action.payload.total,
                    loading: false
                }
            };

        case myAssetsFulfilledConstants.MY_ASSETS_MOBILE_DEVICE_LOADED:
            return {
                ...state,
                mobileDevice: {
                    items: action.payload.items,
                    total: action.payload.total,
                    loading: false
                }
            };

        case myAssetsFulfilledConstants.MY_ASSETS_RESERVATION_LOADED:
            return {
                ...state,
                reservedDevice: {
                    items: action.payload.items,
                    total: action.payload.total,
                    loading: false
                }
            };

        case myAssetsFulfilledConstants.MY_ASSETS_TRANSITION_LOADED:
            return {
                ...state,
                transitedDevice: {
                    items: action.payload.items,
                    total: action.payload.total,
                    loading: false
                }
            };

        case myAssetsFulfilledConstants.MY_ASSETS_LICENSE_LOADED:
            return {
                ...state,
                license: {
                    items: action.payload.items,
                    total: action.payload.total,
                    loading: false
                }
            };

        case devicesFulfilledConstants.DEVICE_PROFILE_INFO_LOADED:
            const { data, deviceId } = action.payload;
            const isReservationDevice = state.reservedDevice.items.some(e => e.id === deviceId);
            const isTransitedDevice = state.transitedDevice.items.some(e => e.id === deviceId);
            const name = isReservationDevice ? 'reservedDevice' : (isTransitedDevice ? 'transitedDevice' : 'device');
            return {
                ...state,
                [name]: {
                    items: state[name].items.map(item => (item.id === deviceId ? { ...item, profileData: data, isLoading: false, error: '' } : item)),
                },
                isLoading: false,
            };
        case devicesPendingConstants.DEVICE_PROFILE_INFO_LOADED:
            const { meta } = action;
            const isReservation = state.reservedDevice.items.some(e => e.id === meta);
            const isTransited = state.transitedDevice.items.some(e => e.id === meta);
            const nameDevice = isReservation ? 'reservedDevice' : (isTransited ? 'transitedDevice' : 'device');
            return {
                ...state,
                [nameDevice]: {
                    items: state[nameDevice].items.map(item => (item.id === meta ? { ...item, profileData: { isLoading: true, error: '' } } : item)),
                },
            };
        case devicesRejectedConstants.DEVICE_PROFILE_INFO_LOADED:
            const error = action.payload;

            return {
                ...state,
                device: {
                    ...state.device,
                    devices: state.device.items.map(item =>
                        (item.id === action.meta
                            ? { ...item, profileData: { isLoading: false, error: error.message } }
                            : item
                        )),
                },
                isLoading: false,
            };

        case myAssetsRejectedConstants.MY_ASSETS_LICENSE_LOADED:
        case myAssetsRejectedConstants.MY_ASSETS_RESERVATION_LOADED:
        case myAssetsRejectedConstants.MY_ASSETS_TRANSITION_LOADED:
        case myAssetsRejectedConstants.MY_ASSETS_MOBILE_DEVICE_LOADED:
        case myAssetsRejectedConstants.MY_ASSETS_DEVICE_LOADED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
